import { MultipleMatchingConflict } from "@common/dto/financialAccount/mergeFinancialAccounts/multiple-matching-conflict.dto";
import { FormCheckbox } from "@components/forms/FormCheckbox/FormCheckbox";
import classNames from "classnames";
import gridTableStyles from "@general/Tables/GridTable/GridTableBase.module.scss";
import { TransactionToMerge } from "./TransactionToMerge";
import styles from "./MultipleMatchingConflicts.module.scss";

interface Props {
    conflict: MultipleMatchingConflict;
    resolutions: Array<{
        fromDestination: number;
        toKeep: number;
    }>;
    onResolve: (
        resolutions: Array<{
            fromDestination: number;
            toKeep: number;
        }>,
    ) => void;
}

export const MultipleMatchingConflictResolving: React.FC<Props> = ({
    conflict,
    resolutions,
    onResolve,
}) => {
    const handleSelectTransaction = (
        fromDestination: number,
        toKeep: number,
    ) => {
        const isAlreadySelected = resolutions.find(
            (resolution) => resolution.fromDestination === fromDestination,
        );

        if (isAlreadySelected && isAlreadySelected.toKeep !== toKeep) {
            return onResolve([
                ...resolutions.filter(
                    (resolution) =>
                        resolution.fromDestination !== fromDestination,
                ),
                { fromDestination, toKeep },
            ]);
        }

        onResolve([...resolutions, { fromDestination, toKeep }]);
    };

    return (
        <div
            className={classNames(gridTableStyles.gridTable, styles.table)}
            key={conflict.transactionFromDestination.id}
        >
            <div className={gridTableStyles.headerRow}>
                <div className={styles.headerCell}>In destination</div>
            </div>
            <TransactionToMerge
                transaction={conflict.transactionFromDestination}
                prepend={
                    <div>
                        <FormCheckbox
                            type="radio"
                            isChecked
                            value={conflict.transactionFromDestination.id}
                            disabled
                        />
                    </div>
                }
            />
            <div className={gridTableStyles.headerRow}>
                <div className={styles.headerCell}>To merge</div>
            </div>
            {conflict.transactionsToMerge.map((transaction) => (
                <TransactionToMerge
                    transaction={transaction}
                    key={transaction.id}
                    prepend={
                        <div>
                            <FormCheckbox
                                type="radio"
                                isChecked={resolutions.some(
                                    (resolution) =>
                                        resolution.toKeep === transaction.id &&
                                        resolution.fromDestination ===
                                            conflict.transactionFromDestination
                                                .id,
                                )}
                                value={transaction.id}
                                handleChange={() => {
                                    handleSelectTransaction(
                                        conflict.transactionFromDestination.id,
                                        transaction.id,
                                    );
                                }}
                                disabled={resolutions.some(
                                    (resolution) =>
                                        resolution.toKeep === transaction.id,
                                )}
                            />
                        </div>
                    }
                />
            ))}
        </div>
    );
};
